// extracted by mini-css-extract-plugin
module.exports = {"link":"review-cards-list_link__91i7e","listItem":"review-cards-list_listItem__LpMkK","noResults":"review-cards-list_noResults__bQ4LW"};